// Helpers/selectors
const getSessionProviderUniqueName = props =>
	props &&
	props.sessionProvider &&
	props.sessionProvider.provider &&
	props.sessionProvider.provider.profile &&
	props.sessionProvider.provider.profile.uniqueName;
const getSessionProviderUUID = props =>
	props &&
	props.sessionProvider &&
	props.sessionProvider.provider &&
	props.sessionProvider.provider.uuid;
const getUniqueName = props =>
	props && props.profile && props.profile.profile && props.profile.profile.uniqueName;
const getMatchUniqueName = props =>
	props && props.match && props.match.params && props.match.params.uniqueName;

/**
 * On prop changes on profile page tab, check if we need to re-retrieve profile data.
 * @param nextProps New props
 * @param currentProps Previous props
 */
export const callbackCheckOnPropChanges = (callback, nextProps, currentProps) => {
	// If user logs in/out, we need to re-retrieve data as we may have more/less data available to us
	if (getSessionProviderUUID(nextProps) !== getSessionProviderUUID(currentProps)) {
		callback(nextProps.match.params.uniqueName);
		return;
	}

	const nextMatchUniqueName = getMatchUniqueName(nextProps);
	const prevMatchUniqueName = getMatchUniqueName(currentProps);
	//const nextUniqueName = getUniqueName(nextProps);

	// Retrieve profile if unique name parameter doesn't match currently loaded
	if (nextMatchUniqueName && prevMatchUniqueName !== nextMatchUniqueName) {
		callback(nextMatchUniqueName);
	}
};

export const checkOnPropChanges = (nextProps, currentProps) =>
	callbackCheckOnPropChanges(nextProps.retrieveProfile, nextProps, currentProps);

export const callbackCheckOnInit = (callback, props) => {
	const nextUniqueName = getUniqueName(props);
	const nextMatchUniqueName = getMatchUniqueName(props);

	if (nextMatchUniqueName && nextUniqueName !== nextMatchUniqueName) {
		callback(nextMatchUniqueName);
	}
};

export const checkOnInit = props => callbackCheckOnInit(props.retrieveProfile, props);



// WEBPACK FOOTER //
// ./src/profile/profilePathCheck.js